export const bottomBarAnimationVariants = {
  open: {
    y: 0,
  },
  closed: {
    y: 'calc(100% - 57px)',
  },
};
